import React from 'react'
import { NavLink } from "react-router-dom";

export default function AboutSidelink() {
  return (
    <>
    <div className="page-sidelink">
        <h3>In this section</h3>
        <ul>
            <li>
            <NavLink to="/founder-desk" className={({ isActive }) => isActive ? "active" : ""}>
              Remembering Our Founder
            </NavLink>
          </li>
          <li>
            <NavLink to="/manager-desk" className={({ isActive }) => isActive ? "active" : ""}>
              Welcome From The Manager
            </NavLink>
          </li>
          <li>
            <NavLink to="/director-desk" className={({ isActive }) => isActive ? "active" : ""}>
              Welcome From The Director
            </NavLink>
          </li>
          <li>
            <NavLink to="/our-aim" className={({ isActive }) => isActive ? "active" : ""}>
              Our Aim
            </NavLink>
          </li>
          <li>
            <NavLink to="/our-heritage" className={({ isActive }) => isActive ? "active" : ""}>
              Our Heritage
            </NavLink>
          </li>
          {/* <li>
            <NavLink to="/teaching-staff" className={({ isActive }) => isActive ? "active" : ""}>
              Teaching Staff
            </NavLink>
          </li> */}
          <li>
            <NavLink to="/accreditation-and-affiliation" className={({ isActive }) => isActive ? "active" : ""}>
              Accreditation & Affiliation
            </NavLink>
          </li>
          <li>
            <NavLink to="/why-lps-lucknow-public-school" className={({ isActive }) => isActive ? "active" : ""}>
              Why LPS
            </NavLink>
          </li>
        </ul>
    </div>
    </>
  )
}
